import { ROLE_ADMIN, ROLE_ANALYST, ROLE_TERM_MANAGER } from "./roles";

export const headerScreens = [
  { path: "/terms", label: "Termos", roles: [ROLE_TERM_MANAGER, ROLE_ADMIN] },
  { path: "/users", label: "Usuários", roles: [ROLE_ADMIN] },
  { path: "/notes", label: "Notas", roles: [ROLE_ANALYST] },
  {
    path: "/content-migration",
    label: "Migração de Conteúdo",
    roles: [ROLE_ANALYST, ROLE_ADMIN],
  },
  {
    path: "/groups-performance",
    label: "Desempenho dos Grupos",
    roles: [ROLE_ANALYST, ROLE_ADMIN],
  },
];

export default [...headerScreens];
